import { render, staticRenderFns } from "./uploadReports.vue?vue&type=template&id=2b8e73a8"
import script from "./uploadReports.vue?vue&type=script&lang=js"
export * from "./uploadReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports